import DistanceRange from '../filter_aside/distance_range.js.jsx';
import DistanceToShore from '../filter_aside/distance_to_shore.js.jsx';
import FilterCondition from '../filter_aside/filter_condition.js.jsx';
import PopularServiceTags from '../filter_aside/popular_service_tags.js.jsx';
import PricesRange from '../filter_aside/prices_range.js.jsx';
import {
  BASE_CATEGORY_ID,
  COTTAGE_CATEGORY_ID,
  FISHING_CATEGORY_ID,
  GLAMPING_CATEGORY_ID,
  GUEST_HOUSE_CATEGORY_ID,
  HOTEL_CATEGORY_ID,
  HUNTING_CATEGORY_ID,
  IS_SANATORIUMS,
  PANSION_CATEGORY_ID,
  SANATORII_CATEGORY_ID,
} from '../filter_main.js.jsx';
import ServiceTags from './service_tags.js.jsx';

export default class FilterAside extends React.Component {
  constructor(props) {
    super(props);
    this.distanceToSkiLiftInteraction = this.distanceToSkiLiftInteraction.bind(this);
    this.distanceInteraction = this.distanceInteraction.bind(this);
    this.filter = this.filter.bind(this);
    const filteredTagsProperties = this.props.filters.tags_properties || [];
    const filteredAllCategories = this.props.filters.all_categories || [];
    this.state = {
      is_selected: false,
      filteredCategoryTypes: [],
      filteredTagsProperties: this.props.data.tags_properties.filter((item) =>
        filteredTagsProperties.includes(item.id)
      ),
      filteredAllCategories: this.props.data.all_camp_categories.filter(item =>
        filteredAllCategories.includes(item.id))
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.campsLoaded && !prevProps.campsLoaded || this.props.filters_counts != prevProps.filters_counts) {
      const { data } = this.props;

      let categoryList = data.category_list;
      if (this.props.data.project === 'mirturbaz.ru') {
        const orderCategoriesMT = {
          [BASE_CATEGORY_ID]: 1, // Базы отдыха
          [GLAMPING_CATEGORY_ID]: 2, // Глэмпинги
          [GUEST_HOUSE_CATEGORY_ID]: 3, // Гостевые дома
          [COTTAGE_CATEGORY_ID]: 4, // Коттеджи
          [HOTEL_CATEGORY_ID]: 5, // Отели
          [FISHING_CATEGORY_ID]: 6, // Рыболовные базы
          [HUNTING_CATEGORY_ID]: 7, // Охотничьи базы
          [SANATORII_CATEGORY_ID]: 8, // Санатории
          [PANSION_CATEGORY_ID]: 9, // Пансионаты
        };
        categoryList.sort((a, b) => orderCategoriesMT[a.id] - orderCategoriesMT[b.id]);
      } else if (this.props.data.project === 'ubook.ru') {
        const orderCategoriesUb = {
          [HOTEL_CATEGORY_ID]: 1, // Отели
          [GUEST_HOUSE_CATEGORY_ID]: 2, // Гостевые дома
          [BASE_CATEGORY_ID]: 3, // Базы отдыха
          [GLAMPING_CATEGORY_ID]: 4, // Глэмпинги
          [SANATORII_CATEGORY_ID]: 5, // Санатории
          [PANSION_CATEGORY_ID]: 6, // Пансионаты
          [FISHING_CATEGORY_ID]: 7, // Рыболовные базы
          [HUNTING_CATEGORY_ID]: 8, // Охотничьи базы
        };
        categoryList.sort((a, b) => orderCategoriesUb[a.id] - orderCategoriesUb[b.id]);
      } else if (this.props.data.project === 'kurortix.ru') {
        const desiredIds = [6, 7, 8]; // Санатории (6), Пансионаты (7), Отели (8)

        // Фильтруем категории и переименовываем "Отели" в "СПА отели"
        categoryList = categoryList
          .filter((item) => desiredIds.includes(item.id))
          .map((item) => (item.id === 8 ? { ...item, name: 'СПА отели' } : item));

        // Порядок: Санатории, Пансионаты, СПА отели
        const order = {
          6: 1, // Санатории
          7: 2, // Пансионаты
          8: 3, // СПА отели
        };

        // Сортируем категории по заданному порядку
        categoryList.sort((a, b) => order[a.id] - order[b.id]);
      }

      this.setState({
        filteredCategoryTypes: categoryList
      });
    }
  }

  distanceInteraction() {
    this.props.distanceInteraction();
  }

  distanceToSkiLiftInteraction() {
    this.props.distanceToSkiLiftInteraction();
  }

  filter(key, value) {
    const { filters } = this.props;
    filters[key] = value;
    this.props.filter(filters);
  }

  render() {
    let prices =
      !this.props.is_foreign &&
      (!this.props.show_chosen ||
        this.props.filters.prices[0] > 0 ||
        this.props.filters.prices[1] < this.props.price_max_end) ? (
        <PricesRange
          filter={this.filter}
          title={'Цена'}
          prices={this.props.filters.prices}
          initPrices={this.props.initPrices}
          max_end={this.props.price_max_end}
          filterValue='prices'
        />
      ) : undefined;

    const areaCenterDefaultDistance = this.props.data.default_distance || this.props.data.max_distance;
    const areaCenterNotDefault =
      this.props.filters.distance && this.props.filters.distance !== areaCenterDefaultDistance;

    let areaCenterRange =
      this.props.data.area_center && (!this.props.show_chosen || areaCenterNotDefault) ? (
        <DistanceRange
          filter={this.filter}
          default_distance={areaCenterDefaultDistance}
          max_distance={this.props.data.max_distance}
          value={this.props.filters.distance}
          title={`От ${this.props.data.city_name_genitive ?? this.props.data.area_center}`}
          distanceInteraction={this.distanceInteraction}
          filterValue='distance'
        />
      ) : undefined;

    let shoreRange =
      this.props.data.shore_distances &&
      this.props.data.shore_distances.length > 1 &&
      (!this.props.show_chosen || this.props.filters.shoreDistance) ? (
        <DistanceToShore
          filter={this.filter}
          value={this.props.filters.shoreDistance}
          counts={this.props.filters_counts?.shoreDistance}
          shore_distances={this.props.data.shore_distances}
        />
      ) : undefined;

    const filter_categories = this.props.filter_values.categories;
    const shouldDisplayTreatment =
      IS_SANATORIUMS ||
      (filter_categories.length > 0 &&
        filter_categories.every((category) => [SANATORII_CATEGORY_ID, PANSION_CATEGORY_ID].includes(category)));

    const treatmentTags = Array.isArray(this.props.data.camp_treatment_profiles) ?
      this.props.data.camp_treatment_profiles :
      [];
    let treatmentProfiles =
      shouldDisplayTreatment &&
      treatmentTags.length > 0 &&
      this.props.sanatoriums ? (
        <ServiceTags
          service_name={'Профили лечения'}
          condition_param={'campTreatmentProfiles'}
          filter={this.filter}
          value={this.props.filters.campTreatmentProfiles}
          counts={this.props.filters_counts?.camp_service_tags}
          campServiceTags={treatmentTags}
          show_chosen={this.props.show_chosen}
        />
      ) : undefined;

    let recovery = shouldDisplayTreatment && (
      <FilterCondition
        condition_name={'Оздоровление'}
        condition_param={'recovery'}
        filter={this.filter}
        enabled_ids={this.props.filters.recovery}
        condition_items={this.props.data.recovery}
        show_chosen={this.props.show_chosen}
      />
    );

    let treatment_profiles_tags =
      shouldDisplayTreatment &&
      this.props.data.treatment_profiles_tags &&
      this.props.data.treatment_profiles_tags.length > 0 &&
      (!this.props.show_chosen || this.props.filters.treatment_profiles_tags?.length > 0) ? (
        <ServiceTags
          service_name={'Лечебный фактор'}
          condition_param={'treatment_profiles_tags'}
          filter={this.filter}
          counts={this.props.filters_counts?.camp_service_tags}
          value={this.props.filters.treatment_profiles_tags}
          campServiceTags={this.props.data.treatment_profiles_tags}
        />
      ) : null;

    let promotions =
      this.props.data.camp_promotions && this.props.data.camp_promotions.length > 0 ? (
        <ServiceTags
          service_name={'Акции'}
          condition_param={'campPromotions'}
          filter={this.filter}
          counts={this.props.filters_counts?.camp_service_tags}
          value={this.props.filters.campPromotions}
          campServiceTags={this.props.data.camp_promotions}
          show_chosen={this.props.show_chosen}
        />
      ) : undefined;

    let popularServiceTags =
      this.props.data.camp_service_tags && this.props.data.camp_service_tags.length > 0 ? (
        <PopularServiceTags
          service_name={'Популярные услуги'}
          condition_param={'campServiceTags'}
          filter={this.filter}
          value={this.props.filters.campServiceTags}
          campServiceTags={this.props.data.camp_service_tags}
          show_chosen={this.props.show_chosen}
          counts={this.props.filters_counts?.camp_service_tags}
          tags_param={'tags_properties'}
          tags_enabled_ids={this.props.filters.tags_properties}
          tags_condition_items={this.state.filteredTagsProperties}
          filtered_tags_properties={this.state.filteredTagsProperties.length > 0}
        />
      ) : undefined;

    let categoryForKids =
      this.props.data.childcare_tags && this.props.data.childcare_tags.length > 0 ? (
        <ServiceTags
          service_name={'Для детей'}
          condition_param={'childcareTags'}
          filter={this.filter}
          counts={this.props.filters_counts?.camp_service_tags}
          value={this.props.filters.childcareTags}
          campServiceTags={this.props.data.childcare_tags}
          show_chosen={this.props.show_chosen}
        />
      ) : undefined;

    let locations =
      this.props.data.camp_locations && this.props.data.camp_locations.length > 0 ? (
        <ServiceTags
          service_name={'Расположение'}
          condition_param={'campLocations'}
          filter={this.filter}
          counts={this.props.filters_counts?.camp_service_tags}
          value={this.props.filters.campLocations}
          campServiceTags={this.props.data.camp_locations}
          show_chosen={this.props.show_chosen}
        />
      ) : undefined;

    let stars =
      this.props.data.stars && this.props.data.stars.length > 0 ? (
        <FilterCondition
          condition_name={'Количество звезд'}
          condition_param={'stars'}
          filter={this.filter}
          orMode
          enabled_ids={this.props.filters.stars}
          condition_items={this.props.data.stars}
          counts={this.props.filters_counts?.stars}
          show_chosen={this.props.show_chosen}
        />
      ) : undefined;

    const districtList = [...Array.from(new Set(this.props.data.districts ?? []))];

    let districts =
      districtList.length > 0 ? (
        <FilterCondition
          condition_name={'Районы'}
          condition_param={'districts'}
          filter={this.filter}
          orMode
          enabled_ids={this.props.filters.districts}
          show_chosen={this.props.show_chosen}
          condition_items={districtList}
        />
      ) : undefined;

    const waterList = [...Array.from(new Set(this.props.data.waters))];

    const waters = waterList?.length > 0 && (
      <FilterCondition
        condition_name={'Водоемы поблизости'}
        condition_param={'waters'}
        filter={this.filter}
        orMode
        enabled_ids={this.props.filters.waters}
        counts={this.props.filters_counts?.waters}
        condition_items={waterList}
        show_chosen={this.props.show_chosen}
      />
    );

    const poolList = this.props.data.swimming_pools_properties;

    const swimmingPoolsProperties =
      poolList?.length > 0 && (!this.props.show_chosen || this.props.filters.swimming_pools_properties?.length > 0) ? (
        <FilterCondition
          condition_name={'Бассейн'}
          condition_param={'swimming_pools_properties'}
          filter={this.filter}
          orMode
          filtered_all_categories={'true'}
          enabled_ids={this.props.filters.swimming_pools_properties}
          show_chosen={this.props.show_chosen}
          condition_items={Array.from(new Set(poolList))}
          counts={this.props.filters_counts?.swimming_pools_properties}
        />
      ) : undefined;

    let bathhouses =
      this.props.data.camp_bathhouses &&
      this.props.data.camp_bathhouses.length > 0 &&
      this.props.data.visible_blocks_filters.baths ? (
        <ServiceTags
          service_name={'Бани и сауны'}
          condition_param={'bathTags'}
          filter={this.filter}
          orMode
          value={this.props.filters.bathTags}
          show_chosen={this.props.show_chosen}
          counts={this.props.filters_counts?.bathTags}
          campServiceTags={this.props.data.camp_bathhouses}
        />
      ) : undefined;

    let instant =
      (!this.props.show_chosen || this.props.filters.instant?.length > 0) ? (
        <FilterCondition
          condition_name={''}
          condition_param={'instant'}
          filter={this.filter}
          enabled_ids={this.props.filters.instant}
          condition_items={this.props.data.instant}
          show_chosen={this.props.show_chosen}
        />
      ) : undefined;

    const discount = (this.props.filters_counts.discount > 0 || this.props.filters.discount) && (
      <FilterCondition
        condition_name={''}
        condition_param={'discount'}
        filter={this.filter}
        enabled_ids={this.props.filters.discount}
        condition_items={this.props.data.discount}
        show_chosen={this.props.show_chosen}
      />
    )

    const notRequiredPrepayment = (
      <FilterCondition
        condition_name={''}
        condition_param={'notRequiredPrepayment'}
        filter={this.filter}
        enabled_ids={this.props.filters.notRequiredPrepayment}
        condition_items={this.props.data.notRequiredPrepayment}
        show_chosen={this.props.show_chosen}
      />
    )

    const singleRoom = this.props.datesChosen ? (
      <FilterCondition
        condition_name={''}
        condition_param={'singleRoom'}
        filter={this.filter}
        enabled_ids={this.props.filters.singleRoom}
        condition_items={this.props.data.singleRoom}
        show_chosen={this.props.show_chosen}
      />
    ) : undefined;

    const food = (
      <FilterCondition
        condition_name={'Тип питания'}
        condition_param={'foodTypes'}
        filter={this.filter}
        orMode
        enabled_ids={this.props.filters.foodTypes}
        condition_items={this.props.data.food_types ?? []}
        show_chosen={this.props.show_chosen}
        counts={this.props.filters_counts?.foodTypes}
      />
    );

    let categoryList = this.state.filteredCategoryTypes;
    const filteredAllCategories = this.state.filteredAllCategories.length > 0;

    const category = (
      <FilterCondition
        condition_name={'Категория'}
        condition_param={'categories'}
        filter={this.filter}
        orMode
        counts={this.props.filters_counts?.categories}
        enabled_ids={this.props.filters.categories}
        condition_items={categoryList}
        show_chosen={this.props.show_chosen}
        withoutDivider={filteredAllCategories}
      />
    );

    const allCategories = filteredAllCategories &&
      <FilterCondition condition_name={this.props.show_chosen && this.props.filters.categories.length === 0 ? 'Категория' : ''}
                       condition_param={'all_enabled_categories'}
                       filter={this.filter}
                       orMode
                       enabled_ids={this.props.filters.all_enabled_categories}
                       condition_items={this.state.filteredAllCategories}
                       counts={this.props.filters_counts?.all_categories}
                       show_chosen={this.props.show_chosen}
                       withoutTopPadding={true}
      />

    let legend =
      this.props.showManagerMap && !this.props.listShowMode ? (
        <div className='filter-row'>
          <div className='filter-row__title'>Легенда</div>
          <p>Есть места:</p>
          <p>
            <div className='manager-placemark_layout brown' /> - 0 броней
          </p>
          <p>
            <div className='manager-placemark_layout brown-green' /> - 1 бронь
          </p>
          <p>
            <div className='manager-placemark_layout green-brown' /> - 2-4 брони
          </p>
          <p>
            <div className='manager-placemark_layout green' /> - более 4 броней
          </p>
          <p>Нет мест:</p>
          <p>
            <div className='manager-placemark_layout light-gray' /> - 0 броней
          </p>
          <p>
            <div className='manager-placemark_layout gray' /> - 1-4 брони
          </p>
          <p>
            <div className='manager-placemark_layout dark-gray' /> - более 4 броней
          </p>
        </div>
      ) : undefined;

    return (
      <form id='filter' className='aside-filter filter'>

        <div className={`${!this.props.show_chosen ||
        (this.props.show_chosen && (this.props.filters.instant?.length > 0 || this.props.filters.discount?.length > 0)) ? 'filter-row__container' : ''}`}>
          {instant}

          {discount}

          {notRequiredPrepayment}

          {singleRoom}
        </div>

        {promotions}

        {category}

        {allCategories}

        {prices}

        {stars}

        {swimmingPoolsProperties}

        {bathhouses}

        {recovery}

        {treatment_profiles_tags}

        {treatmentProfiles}

        {food}

        {areaCenterRange}

        {shoreRange}

        {waters}

        {locations}

        {districts}

        {categoryForKids}

        {popularServiceTags}

        {legend}
      </form>
    );
  }
}
